import { render, staticRenderFns } from "./documents.saleorders.vue?vue&type=template&id=22659dbb"
import script from "./documents.saleorders.vue?vue&type=script&lang=js"
export * from "./documents.saleorders.vue?vue&type=script&lang=js"
import style0 from "./documents.saleorders.vue?vue&type=style&index=0&id=22659dbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports